import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { Form, Checkbox, Select } from 'antd';
import axios from 'axios';
import * as _ from 'lodash';
import { Icon } from 'dlweb-components';

const AdvancedOptionsForm = ({workingFolder, showAutoName, showZipOptions, folderSettings}) => {

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [policyOptions, setPolicyOptions] = useState([]);
  const [autoPathOptions, setAutoPathOptions] = useState([]);
  const [autoNameOptions, setAutonameOptions] = useState([]);
  const [policyStatusDisabled, setPolicyStatusDisabled] = useState(true);

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  const policyStatusOptions = [
    { label: 'Not Scheduled', value: '0' },
    { label: 'Scheduled', value: '1' },
    { label: 'On Legal Hold', value: '2' },
    { label: 'Expired', value: '3' }
  ];

  const existingFileOptions = [
      { label: 'Replace', value: 'replace' },
      { label: 'Create New Version', value: 'new' },
      { label: 'Create Copy', value: 'copy' },
      { label: 'Auto Increment Filename', value: 'increment' }
  ];

  useEffect(() => {

    if(_.isEmpty(folderSettings)) return;

    setLoading(true);

    const setFormValues = async () => {
      let autoName, autoPath, policy;

      let emptyOption = { label: '', value: ''};

      if(showAutoName) {
        const an = await axios.get(`/api/wt/documents/autoname/read?folderId=${workingFolder}`);
        autoName = await an.data.data.map((item) => ({label: item, value: item}));

        if(autoName.length !== 1) {
          autoName.unshift(emptyOption);
        }

        setAutonameOptions(autoName);
      }
      else {
        autoName = [emptyOption];
      }

      const ap = await axios.get(`/api/wt/documents/autopath/read?folderId=${workingFolder}`);
      autoPath = ap.data.data.map((item) => ({ label: item, value: item}));
      autoPath.unshift(emptyOption);
      setAutoPathOptions(autoPath);

      const pl = await axios.get(`/api/wt/documents/policy/list/read?folderId=${workingFolder}`);
      policy = pl.data.data.map((item) => ({ label: item, value: item}));
      policy.unshift(emptyOption);
      setPolicyOptions(policy);

      if(folderSettings?.policyID) {
        setPolicyStatusDisabled(false);
      }

      form.setFieldsValue(
        {
          fullText: true,
          createNewVersion: true,
          autoName: folderSettings?.autoNameTemplate || autoName[0].value,
          recordPolicy: folderSettings?.policyID || policy[0].value,
          recordPolicyStatus: folderSettings?.policyStatus || policyStatusOptions[0].value,
          autoPath: folderSettings?.autoPathTemplate || autoPath[0].value,
          existingFileBehavior: folderSettings?.existingFiles,
          maintainFolderStructure: folderSettings?.maintainFolderStructure,
          extractZip: folderSettings?.extractZip
        }
      )

      setLoading(false);
    }

    setFormValues();

  }, [folderSettings, form])

  const onFormChange = (changedValues, allValues) => {
    const cvName = changedValues[0].name[0];
    const cvValue = changedValues[0].value;
    
    if(cvName === "recordPolicy") {
      setPolicyStatusDisabled(cvValue === '' ? true : false);
    }
  }

  return (
    <Container>
      <Form
        form={form}
        name="advancedOptionsForm"
        layout='vertical'
        {...formItemLayout}
        initialValues={{
          fullText: true,
          createNewVersion: true,
        }}
        onFieldsChange={onFormChange}
        style={{width: '100%', height: '100%'}}
      >
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
          {showAutoName &&
            <Form.Item label="AutoName Template" name="autoName">
              <Select options={autoNameOptions} />
            </Form.Item>
          }
          <Form.Item label="AutoPath Template" name="autoPath">
            <Select options={autoPathOptions} loading={loading}/>
          </Form.Item>
          <Form.Item label="Record Policy" name="recordPolicy">
            <Select options={policyOptions}  loading={loading}/>
          </Form.Item>
          <Form.Item
            name="recordPolicyStatus"
            label="Record Policy Status"
          >
            <Select options={policyStatusOptions} loading={loading} disabled={policyStatusDisabled}/>
          </Form.Item>
          <Form.Item label="Existing File Behavior" name="existingFileBehavior">
            <Select options={existingFileOptions}  loading={loading}/>
          </Form.Item>
          <Form.Item style={{margin: '10px 0 0 0'}} name="fullText" valuePropName='checked'>
            <Checkbox>Enable full-text searches</Checkbox>
          </Form.Item>
          <Form.Item style={{margin: 0}} name="createNewVersion" valuePropName='checked'>
            <Checkbox >Create new version of the document upon check in</Checkbox>
          </Form.Item>
          {showZipOptions && 
            <>
              <Form.Item style={{margin: 0}} name="extractZip" valuePropName='checked'>
                <Checkbox>Extract zip archives</Checkbox>
              </Form.Item>
              <Form.Item style={{margin: 0}} name="maintainFolderStructure" valuePropName='checked'>
                <Checkbox>Maintain folder structure</Checkbox>
              </Form.Item>
            </>
          }
        </div>
      </Form>
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  .ant-form-item {
    margin: 2px 0;
  }
`
export default AdvancedOptionsForm;